import React, { useEffect, useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Chip, Grid, IconButton, MenuItem, Modal, Paper, Select, Snackbar, TextField, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { EditorState, convertToRaw } from 'draft-js';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';

const initialValue = {
    clientName: "",
    clientNumber: '',
    timeOfBilling: "",
    quantity: '',
    paidDues: '',
    price: '',
    serviceProvider: "6486a77dd7a7c82462df8149",
    serviceFor: "",
    serviceSelected: "",
    start: "",
    end: "",
    billStatus: "",
    appointmentStatus: "",
    giveRewardPoints: '',
    subTotal: '',
    discount: '',
    totalAmount: '',
    branchDetails: "",
    advancedGiven: ""
}

const AddBillings = () => {
    const [formData, setFormData] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const { createClient } = useMain();

    const handleSubmit = async () => {
       
        const { clientName, pincode, gender, clientNumber, address, clientEmail } = formData;
        if (clientName.trim() === '') return setErrorMessage('Client Name is Required');
        if (pincode === '') return setErrorMessage('Pincode is Required');
        if (gender === '') return setErrorMessage('Gender is Required');
        if (clientNumber === '') return setErrorMessage('Client Number is Required');
        if (address === '') return setErrorMessage('address is Required');
        if (clientEmail === '') return setErrorMessage('clientEmail is Required');
        setShowLoader(true);

        const res = await createClient(JSON.stringify({
            ...formData,
            address: { pincode, address }
        }));

        if (res?.statusCode === 200) {
            setSuccessMessage('Client Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            // setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            // setFormData(initialValue);
            setShowLoader(false);
        }
    };
    return (
        <PageContainer title="Generate Bill" description="this is add Bill">
            <DashboardCard title="Generate New Bill">
                <Snackbar
                // open={errorMessage == '' ? false : true}
                // autoHideDuration={6000}
                // onClose={() => {
                //     setErrorMessage('');
                // }}
                // severity="error"
                // message={errorMessage}
                // anchorOrigin={{
                //     vertical: 'top',
                //     horizontal: 'right',
                // }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Client Name'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Service For'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Service Provider'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Contact Number'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectInputs
                                title={'Select Service'}
                                options={['option1', 'option2']}
                            // name={'name'}
                            // value={'value'}
                            // handleChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box>
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <TextInputs
                                            title={'Start end Time'}
                                            // name={'productName'}
                                            // value={formData?.productName}
                                            // handleChange={handleChange}
                                            type={'time'}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextInputs
                                            title={''}
                                            required={false}
                                            // name={'productName'}
                                            // value={formData?.productName}
                                            // handleChange={handleChange}
                                            type={'time'}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Date of Billing'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'date'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Quantity'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Price'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Time of Billing'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'time'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Discount'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>


                {/* {showLoader && <ShowLoader value={showLoader} />}
                {successMessage != '' && <ShowSuccess message={successMessage} />} */}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                    // onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddBillings